import React from 'react';
import PropTypes from 'prop-types';

function SendBudgetButton(props) {
  const buttonText = !props.justSent ? 'Enviar' : 'Enviado';
  let styles = !props.justSent ? 'button button--primary button--big button--highlight' : 'button button--secondary button--big u-white-space-normal u-valign-middle u-margin-bottom-small@only-mobile';
  if (props.isLoading) {
    styles += ' is-loading';
  }

  return (
    <div className={`u-text-center ${props.className}`}>
      <button className={styles} onClick={props.onClick} >
        {buttonText}
        {props.justSent && <span className="button__icon icon icon--check u-success-color"></span>}
      </button>
    </div>
  );
}

SendBudgetButton.propTypes = {
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  justSent: PropTypes.bool,
  className: PropTypes.string,
};

export default SendBudgetButton;


// WEBPACK FOOTER //
// ./src/components/ui/SendBudgetButton.js